// extracted by mini-css-extract-plugin
export default {"stylesNode2":"MyTeamSubordinate_stylesNode2__o-XB0"};